module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a4-3-0bfed73ecc15a88fc5bab2f7b550be76.jpg";